const baseUrl = 'https://kb.aampe.com/';

export { baseUrl };
export const apiDocsUrl = baseUrl + 'api-guide/';

// Provider documentation paths
export const messageProvidersPath =
    baseUrl + 'developer-guide/message-providers/message-pages/';
export const dataSourcesPath =
    baseUrl + 'developer-guide/data-ingest/data-sources/';

export const AGENTIC_LEARNING_DOC_URL =
    baseUrl + 'developer-guide/data-ingest/data-management#agentic-learning';
export const LABELING_YOUR_CONTENT =
    baseUrl + 'user-guide/welcome-to-aampe/how-does-aampe-work/labels';
